import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { GalleryTypeApi } from '../../../../api/gallery-type/gallery-type.api';
import { loginLogApi } from '../../../../api/login-log/login-log.api';
import { dateTimeToView } from '../../../../utils/date.utils';

const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [id_gallery_type, set_id_gallery_type] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const [form, set_form] = useState<{ gallery_type_name: string }>({
        gallery_type_name: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_gallery_type(null);
        set_form({ gallery_type_name: "" })
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("วันที่ เวลา")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("หมายเลขเครื่อง")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ชื่อ - นามสกุล ผู้เข้าใช้งาน")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("ประเภท")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("กิจกรรมใช้งาน")
        },
        // {
        //     id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        // },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            ip_address,
            first_name,
            created_date,
            action,
            last_name,
            roles_name

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: dateTimeToView(created_date) || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: ip_address || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: `${first_name} ${last_name}` || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: roles_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: action
                },
                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     class: matches && data.length > 0,
                //     component: <div className='flex justify-center items-center'>
                //         <OptionsButtonCustom
                //             enableEdit
                //             enableView
                //             enableDelete
                //             onViewClick={() => {
                //                 setShowModal('VIEW');
                //                 set_form(objData)
                //                 set_id_gallery_type(id_gallery_type)
                //             }}
                //             onEditClick={() => {
                //                 setShowModal('EDIT');
                //                 set_form(objData)
                //                 set_id_gallery_type(id_gallery_type)
                //             }}
                //             onDeleteClick={() => handleDeleteList(id_gallery_type)}
                //         />
                //     </div>
                // },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    // const handleDeleteList = (id_gallery_type: number) => {
    //     alertActive(t("ลบหมวดหมู่แกลเลอรี"), t("ต้องการลบหมวดหมู่แกลเลอรี ? "), undefined, undefined, async () => {
    //         dispatch(setLoading());
    //         await GalleryTypeApi.deleteGalleryType(id_gallery_type).then((res) => {
    //             if (res.status < 300) {
    //                 alertSuccess(t("ลบหมวดหมู่แกลเลอรี"), t("ลบหมวดหมู่แกลเลอรี เรียบร้อยแล้ว"))
    //                 handleGetData();
    //             }
    //         }).catch((err) => {
    //             console.log(err)
    //             alertError(t("ลบหมวดหมู่แกลเลอรี"), t("ลบหมวดหมู่แกลเลอรี ไม่สำเร็จ"))
    //         }).finally(() => {
    //             dispatch(unsetLoading());
    //         })
    //     })
    // }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await loginLogApi.getLoginHistory(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    // const handleDownloadReport = async () => {
    //     let query: complaintReport = {}
    //     if (search) query = { ...query, keyword: search }
    //     dispatch(setLoading());
    //     await ReportApi.complaintTypeReport(query).then((res) => {
    //         if (res.status < 300) {
    //             const data = res.data;
    //             const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    //             saveAs(blob_file, t("COMPLAINTS_MANAGE_CATEGORY"))
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //         alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    // const handleGetOneDetail = async (id_complaints_type: number, mode: string) => {
    //     setShowModal(mode);
    //     set_id_complaints_type(id_complaints_type)
    //     dispatch(setLoading());
    //     await ComplaintTypeApi.(id_complaints_type).then((res) => {
    //         if (res.status < 300) {
    //             set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: res.data?.data?.complaints_type_name }))
    //         }
    //     }).catch((err) => console.log(err)).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_gallery_type) {
            await GalleryTypeApi.updateGalleryType(id_gallery_type, { gallery_type_name: form.gallery_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขหมวดหมู่แกลเลอรี"), t('แก้ไขหมวดหมู่แกลเลอรี เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขหมวดหมู่แกลเลอรี"), t("แก้ไขหมวดหมู่แกลเลอรี ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await GalleryTypeApi.createGalleryType({ gallery_type_name: form.gallery_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("สร้างหมวดหมู่แกลเลอรี"), t("สร้างหมวดหมู่แกลเลอรี เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("สร้างหมวดหมู่แกลเลอรี"), t("สร้างหมวดหมู่แกลเลอรี ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        id_gallery_type,
        set_id_gallery_type,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
    }
}

export default ManageState
